<template>
  <div class="btn-change-box">
    <div v-for="item in items" :key="item.value" @click="$emit('input', item.value)"
         :class="['btn-change-item', item.value === value ? 'btn-change-active':'btn-change-normal']">
      {{item.text}}
    </div>
  </div>
</template>

<script>
export default {
  name: "BtnChangeGroup",
  props:{
    items:{
      type:Array,
      default(){
        return []
      }
    },
    value: {
      type: [String,Number],
      required: true // 明确要求必须传值
    }
  },
  watch:{
    items:{
      immediate: true,
      handler(val) {
        if(val.length && !this.value){
          this.$emit('input', val[0].value)  // v-model 语法
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.btn-change-box{
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  .btn-change-item{
    padding: 2px 8px;
    font-size: 14px;
    cursor: pointer;
    border: 2px solid transparent;
    border-radius: 4px;
  }
  .btn-change-normal{
    color: #98A4B2;
  }
  .btn-change-active{
    color: #0083FF;
    border-color: #0083FF;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/YUI/BtnChangeGroup/index.vue